import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export const DESK_SESSION_LOCK_STORAGE_KEY = 'core-desk-session-lock'

type DeskSessionLockState = {
  handoffId: string | null
  siteId: string | null
  lockedAt: string | null
}

type DeskSessionLockActions = {
  lockForDesk: (handoffId: string, siteId: string) => void
  unlockDesk: () => void
}

export type DeskSessionLockTarget = { handoffId: string; siteId: string }

export const useDeskSessionLockStore = create<DeskSessionLockState & DeskSessionLockActions>()(
  persist(
    (set) => ({
      handoffId: null,
      siteId: null,
      lockedAt: null,
      lockForDesk: (handoffId, siteId) =>
        set({ handoffId, siteId, lockedAt: new Date().toISOString() }),
      unlockDesk: () => set({ handoffId: null, siteId: null, lockedAt: null }),
    }),
    { name: DESK_SESSION_LOCK_STORAGE_KEY }
  )
)

export const isDeskSessionLocked = (state: DeskSessionLockState): boolean => state.lockedAt !== null

export const readDeskSessionLockTarget = (
  state: DeskSessionLockState
): DeskSessionLockTarget | null =>
  state.handoffId && state.siteId ? { handoffId: state.handoffId, siteId: state.siteId } : null

export const rehydrateDeskSessionLock = (event: Pick<StorageEvent, 'key'>): boolean => {
  if (event.key !== DESK_SESSION_LOCK_STORAGE_KEY && event.key !== null) {
    return false
  }
  void useDeskSessionLockStore.persist.rehydrate()
  return true
}
